import React from 'react';
import { observer } from 'mobx-react';
import { DeckSummaryCardWrapper } from '@seedlang/hoc';
import styled from '@emotion/styled';
import { DeckUI, AppUI } from '@seedlang/state';
import CardButtons from 'components/card/card_buttons';
import { flexCenter } from '@seedlang/style_mixins';
import Text from 'components/text';
import { Theme } from '@seedlang/constants';
import { pixify } from '@seedlang/utils';
import CardWrapper from 'components/layout/card_wrapper';
import CardContent from 'components/layout/card_content';
import NextButton from 'components/button/next_button';
import SelectionButton from 'components/button/selection_button';
import InPlaceSelect from 'components/form/in_place_select';
import DeckSummaryRow from 'components/card/deck_summary_row';

const Table = styled.div`
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;

const FaqTitleWrapper = styled.div`
  text-align: center;
  font-style: italic;
  cursor: pointer;
  text-decoration: underline;
  font-size: 12px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 10px;
  background: ${props => props.background};
  text-align: left;
  position: relative;
  justify-content: flex-end;
  width: 100%;
  min-height: 40px;
  align-items: center;
  .inner-row {
    display: flex;
    width: 100%;
  }
  .already-added {
    font-size: 12px;
    font-style: italic;
    color: ${Theme.gray};
  }
`;

const ButtonWrapper = styled.div`
  ${flexCenter()}
  width: 120px;
`;

const InnerContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  padding: 20px 10px;
  background: white;
  overflow: auto;
  margin-bottom: 10px;
  border-radius: 10px;
`;

const Question = styled.div`
  margin: 5px 0;
  font-weight: bold;
`;

const Answer = styled.div`
  padding: 0 10px 10px 10px;
  font-size: 14px;
  line-height: 18px;
  margin: 0 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    margin-top: 5px;
    cursor: pointer;
  }
`;

const FaqWrapper = styled.div`
  width: 100%;
  border-radius: 5px;
  padding: 10px;
  margin-top: 10px;
`;

const Faq = styled.div`
  background: ${props => props.background};
  padding: 10px 0;
`;

const Header = styled.div`
  cursor: pointer;
  i {
    margin: 4px 0 0 5px;
    font-size: 17px;
  }
`;

const TranslationWrapper = styled.div`
  flex: 1;
  font-weight: ${props => props.fontWeight};
  font-size: 14px;
  display: flex;
`;

const CardTypeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  background: whitesmoke;
  padding: 5px 0;
`;

@observer
class DeckSummaryCard extends React.Component {

  render() {
    return (
      <CardWrapper>
        <CardContent
          scroll
        >
          <InnerContent>
            <Header>
              <Text
                heading='3'
              >
                Create Reviews
              </Text>
            </Header>
            <FaqTitleWrapper
              onClick={this.props.toggleShowFaq}
            >
              What are Reviews?
            </FaqTitleWrapper>
            {
              this.props.showFaq &&
              <FaqWrapper>
                {
                  this.props.faqItems.map((item, index) => {
                    return (
                      <Faq
                        key={item.question}
                        background={index % 2 === 0 ? 'whitesmoke' : '#FFF'}
                      >
                        <Question>
                          {item.question}
                        </Question>
                        <Answer>
                          {item.answerWeb || item.answer}
                          {
                            item.image &&
                            <img
                              style={{ width: pixify(item.imageWidth) }}
                              src={`/images/${item.image}`}
                              onClick={() => AppUI.routeStore.routeToNamed(item.webRoute)}
                              alt=''
                            />
                          }
                        </Answer>
                      </Faq>
                    );
                  })
                }
              </FaqWrapper>
            }
            {
              this.props.reviewDeckOptions.length > 1 &&
              <InPlaceSelect
                allowUpdate
                margin='20px 0 0 0'
                options={this.props.reviewDeckOptions}
                value={this.props.deckId}
                onChange={val => this.props.onSetDeckId(val)}
              />
            }
            <Table>
              {
                this.props.cardTypesForPotentialReview.map(item => {
                  return (
                    <CardTypeWrapper
                      key={item.cardTypeId}
                    >
                      <Row>
                        <TranslationWrapper
                          fontWeight='bold'
                        >
                          {item.cardTypeName} Cards
                        </TranslationWrapper>
                        {
                          !this.props.allReviewsSelectedForCardType(item.cardTypeId) && this.props.cardsForPotentialReview && this.props.cardsForPotentialReview.filter(card => card.cardType.id === item.cardTypeId).length > 1 &&
                          <ButtonWrapper>
                            <SelectionButton
                              width='110px'
                              background='#FFF'
                              icon={<i className='fa fa-plus' />}
                              onClick={() => this.props.onReviewAllForCardType(item.cardTypeId)}
                            >
                              Review All
                            </SelectionButton>
                          </ButtonWrapper>
                        }
                      </Row>
                      {
                        this.props.cardsForPotentialReview?.filter(card => card.cardType.id === item.cardTypeId && this.props.showCardInSummary(card)).map(card => {
                          return (
                            <DeckSummaryRow
                              key={card.id}
                              card={card}
                              deckSummaryCard={this}
                              reviewCard={this.props.findReviewCardForCard(card)}
                              decksWithReviewCard={this.props.getDecksWithReviewCard(card)}
                            />
                          );
                        })
                      }
                    </CardTypeWrapper>
                  );
                })
              }
            </Table>
          </InnerContent>
        </CardContent>
        <CardButtons>
          <NextButton
            text='Finish Deck'
            disabled={!this.props.inView}
            onClick={() => DeckUI.advanceCard(this.props.card, this.props.cardState, this.props.userCard)}
            shortcut='1'
            submitOnEnter
          />
        </CardButtons>
      </CardWrapper>
    );
  }
}

export default DeckSummaryCardWrapper(DeckSummaryCard);
